/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-13 15:42:40
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-21 17:57:16
 * @FilePath: \baishu_react_ui\src\components\BsyDataManager\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";

import { BsyUtils } from "../../utils/Utils";
import BsyAlert from "../BsyAlert";
import BsyDataTable from "../BsyDataTable";
import BsyFieldSortPane from "../BsyFieldSortPane";
import BsyFilterPane from "../BsyFilterPane";
import BsyButton from "../BsyButton";
import BsyMsgBubble from "../BsyMsgBubble";
import { BsyWidget } from "../BsyWidget";
import "./index.css";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlertMenu from "../BsyAlertMenu";
import { BsyConfig } from "../../global/BsyConfig";
import BsyMaskLayer from "../BsyMaskLayer";
import BsySLoading from "../BsySLoading";

export default class BsyDataManageRecycle extends BsyWidget {
  static defaultProps = {
    url: "/data/_list",
    isBackup: true,
    appId: "",
    entryId: "",
    formName: "",
    formItems: [],
    formAttr: {},
    showFields: [],
    showFieldsFilter: null,
    showFieldsMeta: [],
    hasExtParams: !1,
    hasFlow: !1,
    dataPerms: {},
    isEtlTable: !1,
    optAuth: null,
    ignoreAuth: !1,
    authGroupId: null,
    onDataFieldSelect: null,
    onParamFieldSelect: null,
    onDataFieldMetaChange: null,
    onSetAuth: null,
    hasDataRecycle: !1,
    printId: "system",
    hAdjust: 15,
    batchType: "", //delete 批量删除 edit 批量修改
    level2Menu: false,
    filterSticky: false,
    filterTopSticky: false,
    ignoreOptAuth: !1,
    ignoreValidate: !1,
    ptlist: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      ...props,
      filterSticky: this.getFilterSticky(props.appId, props.entryId) || false,
    };

    this.renderIndex = 0;
    this.bodyRef = React.createRef();
  }

  getFilterCacheKey = () => {
    const { appId, entryId, authGroupId } = this.state;

    return BsyUtils.Store.getKey("RecyclefilterValue", {
      appId: appId,
      entryId: entryId,
      authGroupId: BsyUtils.isNumber(authGroupId) ? authGroupId : "",
    });
  };

  setFilterCache = (val) => {
    BsyUtils.Store.set(this.getFilterCacheKey(), val);
  };

  getFilterCache = () => {
    if (this.filter) return;
    let res = BsyUtils.Store.get(this.getFilterCacheKey());
    if (res) {
      this.rel = res.rel;
      this.filter = res.cond ? [...res.cond] : [];
    }
  };

  getFilterStickyKey = (appId1, entryId1) => {
    const { appId, entryId } = this.state;

    return BsyUtils.Store.getKey("RecyclefilterSticky", {
      appId: appId1 || appId,
      entryId: entryId1 || entryId,
    });
  };

  setFilterSticky = (val) => {
    BsyUtils.Store.set(this.getFilterStickyKey(), val);
  };

  getFilterSticky = (appId, entryId) => {
    let res = BsyUtils.Store.get(this.getFilterStickyKey(appId, entryId));
    return res;
  };

  getContext = (context) => {
    this.componentContext = context;
  };

  _isFieldSelectable = (a) => {
    let b = this.options;
    return (
      !!a && (!b.optAuth || !(!b.optAuth[a.name] || !b.optAuth[a.name].visible))
    );
  };

  _getFields = (b) => {
    let c = this,
      d = this.options,
      e = [],
      f = [
        "creator",
        "createTime",
        "updateTime",
        "deleter",
        "deleteTime",
        "_id",
      ];

    if (d.hasFlow) {
      if (window.FX.STATIC.DECISION_SWITCH) {
        f.push("flowState", "flowdecision", "chargers");
      } else {
        f.push("flowState", "chargers");
      }
    }
    d.hasUserSource && f.push("ext");
    if (d.isEtlTable) {
      //如果是数据视图，则不需要系统字段
      f = [];
    }
    let g = [];
    let l = [];
    return (
      BsyUtils.forEach(f, function (a, b) {
        let e = BsyUtils.createEntryAttributeField(b, {
          entryId: d.entryId,
        });
        if (e.name === "label") {
          l.push(e);
        } else {
          c._isFieldSelectable(e) && g.push(e);
        }
      }),
      BsyUtils.forEach(d.formItems, function (f, g) {
        let h = { ...g };
        h.formId = d.entryId;
        let i = BsyUtils.getFieldAttr(h, b || BsyConfig().LimitFields.list);
        if (c._isFieldSelectable(i)) {
          if ("subform" === i.type) {
            let j = [];
            BsyUtils.forEach(i.items, function (a, b) {
              c._isFieldSelectable({
                name: [i.name, b.name].join("."),
              }) && j.push(b);
            });
            i.items = j;
          }
          e.push(i);
        }
      }),
      l.concat(e.concat(g))
    );
  };
  _getShowFields = (b, c) => {
    if (c && c.length > 0) {
      let d = [];
      BsyUtils.forEach(b, function (b, e) {
        let f = { ...e };
        if (c.indexOf(f.name) > -1) d.push(f);
        else if ("subform" === f.type) {
          let g = [];
          BsyUtils.forEach(f.items, function (a, b) {
            c.indexOf([f.name, b.name].join(".")) > -1 && g.push(b);
          });
          f.items = g;
          BsyUtils.isObjectEmpty(f.items) || d.push(f);
        }
      });
      return d;
    }
    return b;
  };

  getFilterConfig = () => {
    const { filterSticky, filterTopSticky } = this.state;
    this.getFilterCache();
    return {
      hasRelation: true,
      hasPin: true,
      // hasHeader: filterSticky ? true : false,
      hasHeader: true,
      filterSticky,
      filterTopSticky,
      rel: this.rel || "and",
      cond: this.filter || [],
      entryList: {
        [this.state.entryId]: {
          id: this.state.entryId,
          name: this.state.formName,
          fields: [...this.fields],
        },
      },
      onFilterClose: () => {
        this.filterPaneContext && this.filterPaneContext.onRemoveRoot();
        this.setState({
          filterSticky: false,
          filterTopSticky: false,
        });
      },
      onFilterSticky: () => {
        const { filterSticky, filterTopSticky } = this.state;
        if (!filterSticky) {
          this.filterPaneContext && this.filterPaneContext.onRemoveRoot();
        }
        this.setState({
          filterSticky: !filterSticky,
          filterTopSticky: !filterSticky ? false : filterTopSticky,
        });
      },
      onFilterTopSticky: () => {
        const { filterTopSticky, filterSticky } = this.state;
        if (!filterTopSticky) {
          this.filterPaneContext && this.filterPaneContext.onRemoveRoot();
        }

        this.setState({
          filterSticky: !filterTopSticky ? false : filterSticky,
          filterTopSticky: !filterTopSticky,
        });
      },
      onSetFieldFilter: (val) => {
        this.rel = val.rel;
        this.filter = [...val.cond];
      },
      onFilter: (val) => {
        this.rel = val.rel;
        this.filter = [...val.cond];
        this.componentContext.reload();
        this.setFilterCache(val);
      },
    };
  };

  operationPane = (event, type) => {
    let filter = this.componentContext.getFilterData();
    let selectDataId = this.componentContext.selectDataId;
    let bts = [
      {
        icon: "",
        name: React.language("data.manager.filterdata.edit"),
        type: "filter",
        customCls: BsyUtils.isObjectEmpty(filter) ? " bsy-ui-disable" : "",
      },
      {
        icon: "",
        name: React.language("data.selected"),
        type: "select",
        customCls: BsyUtils.isObjectEmpty(selectDataId)
          ? " bsy-ui-disable"
          : "",
      },
      {
        icon: "",
        name: React.language("data.manager.alldata.edit"),
        type: "all",
        customCls: "",
      },
    ];
    let menus = [];

    for (let index = 0; index < bts.length; index++) {
      const element = bts[index];
      menus.push({
        text: element.name,
        icon: element.icon,
        customCls: element.customCls,
        click: () => {
          this.operation(type, element.type, filter, selectDataId);
        },
      });
    }
    BsyAlertMenu({
      item: menus,
      width: 150,
      target: event.currentTarget,
      theme: this.props.theme,
      customCls: " data-manage-batch-menu ",
    });
  };

  operation = (type, isAll, filter, idList, cb) => {
    idList = idList || [];
    switch (type) {
      case "recover": {
        switch (isAll) {
          case "all": {
            BsyAlert({
              title:
                React.language("ok") +
                React.language("recover") +
                React.language("all.data.tip"),
              type: "warning",
              text4Ok: React.language("recover"),
              OkType: "blue",
              text4Cancel: React.language("cancel"),
              ok: () => {
                let layerRef = null;
                BsyMaskLayer({
                  customCls: "sloading",
                  onContentCreate: (ref) => {
                    layerRef = ref;
                    return (
                      <div>
                        <BsySLoading />{" "}
                      </div>
                    );
                  },
                });

                React.axios(`/data/recover`, {
                  appId: this.state.appId,
                  entryId: this.state.entryId,
                  formId: this.state.entryId,
                  isBackup: true,
                  recoverAll: true,
                }).then((res) => {
                  this.componentContext.reload();
                  cb && cb();
                  layerRef && layerRef.close();
                });
              },
            });
            break;
          }
          case "filter": {
            BsyAlert({
              title:
                React.language("ok") +
                React.language("recover") +
                React.language("data.manager.filterdata.edit"),
              type: "warning",
              text4Ok: React.language("recover"),
              OkType: "blue",
              text4Cancel: React.language("cancel"),
              ok: () => {
                let layerRef = null;
                BsyMaskLayer({
                  customCls: "sloading",
                  onContentCreate: (ref) => {
                    layerRef = ref;
                    return (
                      <div>
                        <BsySLoading />{" "}
                      </div>
                    );
                  },
                });
                React.axios(`/data/recover`, {
                  appId: this.state.appId,
                  entryId: this.state.entryId,
                  formId: this.state.entryId,
                  filter: filter,
                  jsplatform: "React",
                  isBackup: true,
                  recoverAll: false,
                }).then((res) => {
                  layerRef && layerRef.close();
                  this.componentContext.reload();
                  cb && cb();
                });
              },
            });
            break;
          }
          default: {
            if (idList.length) {
              BsyAlert({
                title:
                  React.language("form.data.select", {
                    length: idList.length,
                  }) +
                  React.language("ok") +
                  React.language("recover") +
                  "?",
                type: "warning",
                text4Ok: React.language("recover"),
                OkType: "blue",
                text4Cancel: React.language("cancel"),
                ok: () => {
                  let layerRef = null;
                  BsyMaskLayer({
                    customCls: "sloading",
                    onContentCreate: (ref) => {
                      layerRef = ref;
                      return (
                        <div>
                          <BsySLoading />{" "}
                        </div>
                      );
                    },
                  });
                  React.axios(`/data/recover`, {
                    appId: this.state.appId,
                    entryId: this.state.entryId,
                    formId: this.state.entryId,
                    idList: idList,
                    isBackup: true,
                    recoverAll: false,
                  }).then((res) => {
                    layerRef && layerRef.close();
                    this.componentContext.reload();
                    cb && cb();
                  });
                },
              });
            } else {
              tipAlert({
                type: "warning",
                msg: React.language("select.data.empty.tip"),
              });
            }
            break;
          }
        }

        break;
      }
      case "delete": {
        switch (isAll) {
          case "all": {
            BsyAlert({
              title: React.language("want.clear.form.data", {
                name: this.state.formName,
              }),
              msg: React.language("clear.select.form.data.irreversible"),
              type: "error-input",
              text4Ok: React.language("delete"),
              OkType: "red",
              onInputValidate: (val) => {
                return val === this.state.formName;
              },
              placeholder: React.language("delete.form.data"),
              text4Cancel: React.language("cancel"),
              ok: (value, ref) => {
                // if(value ==)
                React.axios(`/data/hard_remove`, {
                  appId: this.state.appId,
                  entryId: this.state.entryId,
                  formId: this.state.entryId,
                  filter: {}, //this.componentContext.getFilterData(),
                  isBackup: true,
                  clearAll: true,
                }).then((res) => {
                  this.componentContext.reload();
                  cb && cb();
                });
              },
            });
            break;
          }
          case "filter": {
            BsyAlert({
              title: React.language("want.clear.form.data.filter", {
                name: this.state.formName,
              }),
              msg: React.language("clear.select.form.data.irreversible"),
              type: "error-input",
              text4Ok: React.language("delete"),
              OkType: "red",
              onInputValidate: (val) => {
                return val === this.state.formName;
              },
              placeholder: React.language("delete.form.data"),
              text4Cancel: React.language("cancel"),
              ok: () => {
                // this.componentContext.BBY_doDeleteData(idList, false, filter)
                React.axios(`/data/hard_remove`, {
                  appId: this.state.appId,
                  entryId: this.state.entryId,
                  formId: this.state.entryId,
                  filter: filter,
                  jsplatform: "React",
                  isBackup: true,
                  clearAll: false,
                }).then((res) => {
                  this.componentContext.reload();
                  cb && cb();
                });
              },
            });

            break;
          }
          default: {
            if (idList.length) {
              BsyAlert({
                title: React.language("want.clear.form.data.select", {
                  name: this.state.formName,
                  index: idList.length,
                }),
                msg: React.language("clear.select.form.data.irreversible"),
                type: "error-input",
                text4Ok: React.language("delete"),
                OkType: "red",
                onInputValidate: (val) => {
                  return val === this.state.formName;
                },
                placeholder: React.language("delete.form.data"),
                text4Cancel: React.language("cancel"),
                ok: () => {
                  // this.componentContext.BBY_doDeleteData(idList, false, filter)
                  React.axios(`/data/hard_remove`, {
                    appId: this.state.appId,
                    entryId: this.state.entryId,
                    formId: this.state.entryId,
                    filter: {},
                    isBackup: true,
                    idList: idList,
                    clearAll: false,
                  }).then((res) => {
                    this.componentContext.reload();
                    cb && cb();
                  });
                },
              });
            } else {
              tipAlert({
                type: "warning",
                msg: React.language("select.data.empty.tip"),
              });
            }
            break;
          }
        }

        break;
      }

      default: {
      }
    }
  };

  renderHeaderMenu = () => {
    return (
      <>
        <div
          className="BsyBtn"
          onClick={(e) => {
            this.operationPane(e, "recover");
          }}
        >
          <div className="btnCont">
            <span>{React.language("recover")}</span>
            <i
              className="icon-bby-xiala"
              style={{
                margin: 0,
              }}
            ></i>
          </div>
        </div>

        <div
          className="BsyBtn"
          onClick={(e) => {
            this.operationPane(e, "delete");
          }}
        >
          <div className="btnCont">
            <span>{React.language("delete.hard")}</span>
            <i
              className="icon-bby-xiala"
              style={{
                margin: 0,
              }}
            ></i>
          </div>
        </div>
      </>
    );
  };

  onGetFilterPaneContext = (context) => {
    this.filterPaneContext = context;
  };

  createHeader = () => {
    const { filterSticky } = this.state;
    let _opt = this.props;
    let key = "menu" + this.renderIndex++;
    let that = this;
    return (
      <div className="bsy-data-manage-block-head">
        <div className="block-menu" key={key}>
          {this.renderHeaderMenu()}
        </div>

        <div className="block-menu-right">
          {!filterSticky && (
            <BsyButton
              // text={React.language("filter.condition")}
              tip={React.language("filter.condition")}
              type={"menu-right"}
              iconName={"icon-bsy-shaixuananniu"}
              click={(e) => {
                let config = this.getFilterConfig();

                BsyMsgBubble({
                  anchor: e.currentTarget,
                  onGetContext: this.onGetFilterPaneContext,
                  contentHTML: (ref) => {
                    return (
                      <BsyFilterPane
                        {...config}
                        hasSticky={true}
                      ></BsyFilterPane>
                    );
                  },
                  text4Cancel: null,
                  text4Ok: null,
                  theme: this.props.theme,
                  minWidth: "auto",
                  width: 350,
                  contentPadding: 0,
                  edge: 200,
                  hAdjust: 72,
                  dockPosition: "right",
                  onClose: function () {
                    that.setState({});
                    return !1;
                  },
                });
              }}
              mode={window.mode}
            />
          )}
          {
            <BsyButton
              // text={React.language("refresh")}
              tip={React.language("refresh")}
              type={"menu-right"}
              iconName={"icon-async"}
              click={() => {
                this.componentContext.reload();
              }}
              mode={window.mode}
            />
          }

          {
            <BsyButton
              // text={React.language("field.show")}
              tip={React.language("sort")}
              type={"menu-right"}
              iconName={"icon-bsy-iconpaixu"}
              click={(e) => {
                // this.componentContext.BBY_doSetFields(e)

                let config = {
                  appId: _opt.appId,
                  entryId: _opt.entryId,
                  formId: _opt.entryId,
                  name: that.state.formName,
                  entryList: {
                    [that.state.entryId]: {
                      id: that.state.entryId,
                      name: that.state.formName,
                      fields: [...that.fields],
                    },
                  },
                  sort: that.componentContext.state.sort,
                };

                BsyMsgBubble({
                  anchor: e.currentTarget,
                  contentHTML: (ref) => {
                    return (
                      <BsyFieldSortPane
                        {...config}
                        onSort={(sort) => {
                          that.componentContext.reload({
                            skip: 0, //??? 是否要回到首页
                            sort: [...sort],
                          });
                          ref.closeAlter();
                        }}
                      ></BsyFieldSortPane>
                    );
                  },
                  text4Cancel: null,
                  text4Ok: null,
                  theme: that.props.theme,
                  minWidth: "auto",
                  width: 350,
                  contentPadding: 0,
                  edge: 200,
                  hAdjust: 72,
                  dockPosition: "right",
                  onClose: function () {
                    // that.setState({

                    // })
                    return !1;
                  },
                });
              }}
              mode={window.mode}
            />
          }

          {
            <BsyButton
              // text={React.language("field.show")}
              tip={React.language("field.show")}
              type={"menu-right"}
              iconName={"icon-page-view"}
              click={(e) => {
                this.componentContext.BBY_doSetFields(e);
              }}
              mode={window.mode}
            />
          }
          {
            <BsyButton
              type={"menu-right"}
              iconName={"icon-enlarge"}
              click={(e) => {
                if (this.bodyRef.current) {
                  this.bodyRef.current.classList.toggle("manage-fullscreen");
                  e.currentTarget
                    .querySelector("i")
                    .classList.toggle("icon-shrink");
                }
              }}
              mode={window.mode}
            />
          }
        </div>
      </div>
    );
  };

  onDataFilter = () => {
    let t = [];
    this.filter && (t = t.concat(this.filter));
    return { filter: t, filterMap: this.filterMap, rel: this.rel || "and" };
  };

  createBody = () => {
    const { asyncExportURL, url, level2Menu } = this.state;
    let that = this;
    let c = this.options,
      e = c.showFields,
      f = c.showFieldsFilter,
      g = this._getFields(),
      h = this._getShowFields(g, e),
      i = BsyConfig().LimitFields.filter,
      j = [];
    BsyUtils.forEach(g, function (a, b) {
      i.indexOf(b.type) > -1 && j.push(b);
    });
    if (c.hasFlow) {
      j.push({
        id: c.entryId,
        name: "flownode",
        type: "flownode",
        text: React.language("flow.node.current"),
      });
      j.push({
        id: c.entryId,
        name: "flow_chargers",
        type: "flow_chargers",
        text: React.language("flow.charger.current"),
      });
    }

    let k = [];
    f && (k = this._getShowFields(j, f));
    this.showFields = g;
    this.fields = h;
    let l = null;
    if (c.formAttr && "grid-2" === c.formAttr.layout) {
      l = {};
      BsyUtils.forEach(c.formItems, function (a, b) {
        l[b.widget.widgetName] = b.lineWidth;
      });
    }

    if (c.dataPerms.flow_delete) c.dataPerms.delete = c.dataPerms.flow_delete;
    if (c.dataPerms.flow_update) c.dataPerms.update = c.dataPerms.flow_update;
    if (c.dataPerms.flow_create) c.dataPerms.create = c.dataPerms.flow_create;
    let m = {};
    BsyUtils.forEach(c.showFieldsMeta, function (a, b) {
      let c = a;
      b.subform && (c = [b.subform, a].join("."));
      m[c] = b;
    });

    c.ptlist = [];
    if (!!c.ignoreAuth) {
      c.ptlist = window.FX.STATIC.ptlist ? window.FX.STATIC.ptlist : [];
    } else {
      BsyUtils.forEach(c.printId, function (a1, b1) {
        c.ptlist.push({
          printId: b1.id,
          name: b1.name,
        });
      });
    }

    let config = {
      url,
      isBackup: true,
      recycle: true,
      asyncExportURL,
      ignoreOptAuth: !!c.ignoreOptAuth,
      ignoreValidate: !!c.ignoreValidate,
      ignoreAuth: !!c.ignoreAuth,
      optAuth: c.optAuth,
      entryId: c.entryId,
      appId: c.appId,
      ptlist: c.ptlist,
      is_dock_form: c.is_dock_form,
      originPrint: c.originPrint,
      multiTabs: c.formTabs,
      formTabsStyle: c.formTabsStyle || {},
      formItems: c.formItems,
      itemEditable: c.dataPerms.update !== !1,
      itemRemovable: c.dataPerms.delete !== !1,
      itemPrintable: !0, //c.dataPerms.batch_print !== !1,      2020 04 18 统一移动端pc端的数据访问的逻辑打印的逻辑r
      itemLog: c.dataPerms.log === !0,
      itemComment: c.dataPerms.comment === !0,
      flow_activate: c.hasFlow && c.dataPerms.flow_activate === !0,
      flow_close: c.hasFlow && c.dataPerms.flow_close === !0,
      flow_transfer: c.hasFlow && c.dataPerms.flow_transfer === !0,
      flow_log: c.hasFlow && c.dataPerms.flow_log === !0,
      resizable: !0,
      isEtlTable: c.isEtlTable,
      showFieldsMeta: m,
      exportable: !1,
      formLayout: l,
      enableRowEdit: false,
      quickEdit: false,
      availableParamFields: j,
      hasFlow: c.hasFlow,
      height4Head: 40,
      width: "100%",
      height: "100%",
      title: c.formName,
      visible4Title: !1,
      fields: h,
      showFields: this.showFields,
      forms: [c.entryId],
      authGroupId: c.authGroupId,
      printId: c.printId,
      widgetId: "form-visit" + c.entryId,
      jsplatform: "React",
      onRecoverData: (a, b, c) => {
        if (b) {
          that.operation("recover", "select", {}, [a], () => {
            c && c();
          });
        } else {
          that.operation("delete", "select", {}, [a], () => {
            c && c();
          });
        }
      },
    };

    return (
      <div className="bsy-data-manage-block-body">
        <BsyDataTable
          {...config}
          skip={this.skip || 0}
          hasCount={false}
          getContext={this.getContext}
          level2Menu={level2Menu}
          key={this.componentKey}
          onDataFilter={this.onDataFilter}
          onReload={() => {
            // 切换可显示字段的时候，会引起样式BUG 需要整个div刷新 2022 06 13 波波
            this.componentKey = "table" + this.renderIndex++;
            this.skip = this.componentContext.state.skip;
            this.setState({}, () => {
              // this.componentContext.loadWidget(null, null, this.skip);
            });
          }}
        />
      </div>
    );
  };
  render() {
    const { filterSticky, filterTopSticky } = this.state;
    return (
      <div
        className={"bsy-data-manage " + (filterSticky ? "filter-sticky" : "")}
        style={{
          height: "100%",
          width: "100%",
        }}
        ref={this.element}
      >
        {filterTopSticky ? (
          this.props.hasFilter ? (
            <BsyFilterPane {...this.getFilterConfig()} hasSticky={true} />
          ) : (
            ""
          )
        ) : (
          ""
        )}
        <div
          className="mamge-body"
          ref={this.bodyRef}
          style={{
            height: "calc(100% - 20px)",
          }}
        >
          {this.createHeader()}
          {this.createBody()}
        </div>
        {filterSticky ? (
          this.props.hasFilter ? (
            <BsyFilterPane {...this.getFilterConfig()} hasSticky={true} />
          ) : (
            ""
          )
        ) : (
          ""
        )}
      </div>
    );
  }
}
